'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    Menu: {
        elements: [{
            number: '01',
            title: 'Slow Camera',
            url: 'slow-camera/'
        }]
    },
    Home: {
        intro: {
            skip: 'Skip Intro',
            messeges: [{
                text: 'Hollywood, the 30\'s'
            }, {
                text: 'Two legs dance swing on an RKO set.'
            }, {
                text: 'It\'s a casting. A company man takes notes about the candidate Frederick Austerlitz:',
                subText: ['Bad acting.', 'Bad acting.', 'Slightly balding.', 'Slightly balding.', 'Also dancing.', 'Also dancing.']
            }, {
                text: 'He was talking about the legend who united dance and film:'
            }, {
                text: 'Fred Astaire'
            }]
        }
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/i18n/en.js
// module id = 724
// module chunks = 0